import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

const hasStoredSession = () => Boolean(localStorage.getItem('token'));

function NotProtectedRoute() {
    useEffect(() => {
        if (!hasStoredSession()) {
            return;
        }

        localStorage.clear();
    }, []);

    return <Outlet />;
}

export default NotProtectedRoute;
